import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_MARK_AS_SENT_SDOH_REPORT')